import { render, staticRenderFns } from "./coach-detail.vue?vue&type=template&id=145b17b7&"
import script from "./coach-detail.vue?vue&type=script&lang=js&"
export * from "./coach-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports